import http from '../api/http'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = ""

//科普中国后台访问测试（测试接口，可删除！！）：
export function testGetDataFromKepuBackendService(params){
  return http.get('h5Api/information/h5ui/list',params)
}

export function getCategory(params){
  return http.get('h5Api/information/h5ui/getCategory',params)
}
export function getKepuInfo(params){
  return http.get('h5Api/information/h5ui/getKepuInfo',params)
}


// get请求
//夏乐西瓜：获取二维码详情
// 夏乐西瓜：获取二维码详情
export function getQrCodeDetails(params){
  return http.get('bt_qrcode_scan/getQrCodeDetails',params)
}


// 列表页
export function getList(params){
  // '/information/article/list'
  return http.get('information/article/getAllPublishedArticleList',params)
  // return http.get('information/article/list', params)
}
// 详情页
export function getDetailList(params){
  //'/information/article/' + id
  return http.detail('information/article/getArticleInfoById/',params.id)
}
// 首页轮播图
export function getCarousel(params){
  return http.get('information/article/getLatestAvator',params)
}
// 导航栏一级
export function getNavLevel(params){
  return http.get('information/casColumnLevel1/getAllLevel1ColumnList',params)
}
// 导航栏二级
export function getNextNavLevel(params){
  return http.get('information/casColumnLevel2/getAllLevel2ColumnList',params)
}
// 机构类型
export function getAgencyType(params){
  return http.get('information/article/getArticleOneFieldAsSelectOptions',params)
}
// 面向数据
export function getOrientedData(params){
  return http.get('information/oriented/getAllOrientedData',params)
}
// 点击面向数据更多查询
export function getAllOrientedData(params){
  return http.get('information/article/getAllPublishedArticleListByOriented',params)
}
// 通过标签查询文章列表
export function getByLabelName(params){
  return http.detail('information/article/getArticleListByLabelName/',params.labelName)
}
// post请求
export function connectUs(params){
  return http.post('XX/XX',params)
}
// put 请求
export function putSomeAPI(params){
  return http.put(resquest,params)
}



// WEBPACK FOOTER //
// ./src/api/api.js